import { ORDER_TYPES } from './constants';

export const isMailOrder = (orderType: string) => {
  return orderType === ORDER_TYPES.MAIL;
};

export const isSiteOrder = (orderType: string) => {
  return orderType === ORDER_TYPES.SITE;
};

export const isDomainOrder = (orderType: string) => {
  return orderType === ORDER_TYPES.DOMAIN;
};

export const hasMailOrder = (orders: any[]) => {
  return orders.some((order) => isMailOrder(order.type));
};

export const hasSiteOrder = (orders: any[]) => {
  return orders.some((order) => isSiteOrder(order.type));
};

export const hasDomainOrder = (orders: any[]) => {
  return orders.some((order) => isDomainOrder(order.type));
};

export const getLatestOrderOfOrderType = (orders: any, orderType: string) => {
  return orders
    .filter(
      (order: { type: string; createdAt: string }) => order.type === orderType
    )
    .sort(
      (a: { createdAt: string }, b: { createdAt: string }) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )[0];
};

export const getLatestMailOrder = (orders: any[]) => {
  return getLatestOrderOfOrderType(orders, ORDER_TYPES.MAIL);
};

export const getLatestSiteOrder = (orders: any[]) => {
  return getLatestOrderOfOrderType(orders, ORDER_TYPES.SITE);
};

export const getLatestDomainOrder = (orders: any[]) => {
  return getLatestOrderOfOrderType(orders, ORDER_TYPES.DOMAIN);
};

export const getOrderTypeFromId = (orders: Array<any>, id: number) => {
  return orders.find((order) => order.id === id)?.type || null;
};

export const getProductFromOrderType = (orderType: string) => {
  switch (orderType) {
    case ORDER_TYPES.MAIL:
      return 'Mail';
    case ORDER_TYPES.SITE:
      return 'Site';
    case ORDER_TYPES.DOMAIN:
      return 'Neo Domain';
    default:
      return null;
  }
};
